<template>
  <div class="flex justify-center items-center">
    <span v-if="this.params.data.status == 2">
      <a
        href="#"
        @click.stop.prevent="onClickAction"
      >分析情報の登録</a>
    </span>
    <span v-if="this.params.data.status == 4">
      <a
        href="#"
        @click.stop.prevent="onClickAction"
      >レポート</a>
    </span>
  </div>
</template>

<script>

import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DataTableCellAnalysis',
  methods: {
    onClickAction () {
      this.params.action(this.params.data)
    }
  }
})
</script>
